import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import useConnections from './hooks/useConnections';
import { ConnectionsContext } from './connectionsContext';

// One read of the connections list for the page: the Connect menu and every Slack entry point share it.
const ConnectionsProvider = ({ children, translate }) => {
    const { connections, loadError, busyId, refresh, connect, disconnect } = useConnections(translate);

    const value = useMemo(() => ({ connections, loadError, busyId, refresh, connect, disconnect }), [
        connections,
        loadError,
        busyId,
        refresh,
        connect,
        disconnect,
    ]);

    return <ConnectionsContext.Provider value={value}>{children}</ConnectionsContext.Provider>;
};

ConnectionsProvider.propTypes = {
    children: PropTypes.node,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(ConnectionsProvider);
